import { combineReducers } from "redux-immutable";

import sessionActionTypes from "seneca-common/features/session/action-types";
import { SESSION_TYPES } from "seneca-common/features/session/models/SessionType";

import { studyWrongAnswerSession } from "../../actions";
import PremiumTrialsStateSlice from "../../models/state/PremiumTrialsStateSlice";
import trialMetaReducer from "./meta";
import trialsStateReducer from "./trials";

const combinedReducer = combineReducers({
  trials: trialsStateReducer,
  meta: trialMetaReducer
}) as any;

function premiumTrialsStateSliceReducer(
  state: PremiumTrialsStateSlice = new PremiumTrialsStateSlice(),
  action: Record<string, any>
): PremiumTrialsStateSlice {
  if (
    action.type === sessionActionTypes.COMPLETE_SESSION &&
    action.payload.sessionType === SESSION_TYPES.wrongAnswers
  ) {
    return combinedReducer(state, studyWrongAnswerSession());
  }

  return combinedReducer(state, action);
}

export default premiumTrialsStateSliceReducer;
